import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LEAVE, LEAVEALL } from '../../services/actions';
import { Button, Box, Typography, Container, Paper } from '@mui/material';
import XTable from '../extra/XTableAnother';
import ActionBar from '../extra/ActionBar';

export default function LeaveApprovals() {
    const dispatch = useDispatch();
    const leaveAllState = useSelector(state => state.leaveallState);
    const leaves = Array.isArray(leaveAllState?.data) ? leaveAllState.data : (leaveAllState?.data?.results || []);

    useEffect(() => {
        dispatch({ type: `${LEAVEALL}_GET`, payload: "attendance/leave/" });
    }, [dispatch]);

    const handleAction = (id, action) => {
        dispatch({ type: `${LEAVE}_POST`, payload: { url: `attendance/leave/${id}/${action}/`, payload: {} } });
        setTimeout(() => dispatch({ type: `${LEAVEALL}_GET`, payload: "attendance/leave/" }), 500);
    };

    const tableHeadings = [
        "User",
        "Type",
        "Dates",
        "Reason",
        "Status",
        "Actions"
    ];

    const tableRows = leaves.map(l => ({
        id: l.id,
        user_name: l.user_name,
        leave_type: l.leave_type,
        dates: `${l.start_date} to ${l.end_date}`,
        reason: l.reason,
        status: l.status,
        actions: l.status === 'Pending' ? (
            <Box display="flex" gap={1}>
                <Button variant="contained" size="small" color="success" onClick={() => handleAction(l.id, 'approve')}>Approve</Button>
                <Button variant="contained" size="small" color="error" onClick={() => handleAction(l.id, 'reject')}>Reject</Button>
            </Box>
        ) : '-'
    }));

    return (
        <Container maxWidth="false" className="py-3">
            <ActionBar
                showGrid={[2]}
                btnImport=""
                label="Leave Approvals"
                setOpen={() => {}}
                hasPermission={false}
                btnLabel=""
            />
            <Paper elevation={0} sx={{ mt: 2 }}>
                <XTable
                    head={tableHeadings}
                    rows={tableRows}
                />
            </Paper>
        </Container>
    );
}
